module.exports = __webpack_public_path__ + "static/media/view1.9d1846fa.jpg";